// Family access tokens — one per family member
// These must match the RLS policy in supabase/migrations/20260223000004_family_chat.sql
export const FAMILY_TOKENS = {
  jordan:    '71de4742-d089-4d97-aaaa-e3c03f70748a',
  chrislynn: '0eca5d84-12c9-4c32-b08c-75ec676723bf',
  cain:      '95cf33c2-88b2-4837-9401-39b3ffefd7d2',
};

export const VALID_TOKENS = new Set(Object.values(FAMILY_TOKENS));

export function getNameForToken(token) {
  for (const [name, t] of Object.entries(FAMILY_TOKENS)) {
    if (t === token) return name.charAt(0).toUpperCase() + name.slice(1);
  }
  return 'Unknown';
}
